<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="search-form">
            <el-form :inline="true" :model="downShopHouseManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input
                  v-model="downShopHouseManageInfo.conditions.personName"
                  placeholder="请输入申请人"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="downShopHouseManageInfo.conditions.orderId"
                  placeholder="请输入单号"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="downShopHouseManageInfo.conditions.state"
                  placeholder="请选择状态"
                  style="width:100%"
                  clearable
                >
                  <el-option
                    v-for="item in downShopHouseManageInfo.states"
                    :key="item.statusCd"
                    :label="item.name"
                    :value="item.statusCd"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryShopHouseMethod">
                  <i class="el-icon-search"></i>查询
                </el-button>
                <el-button @click="_resetShopHouseMethod">
                  <i class="el-icon-refresh"></i>重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>退货单</span>
            <el-button
              type="primary"
              size="small"
              style="float:right"
              @click="_openAddShopHouseModal"
            >
              <i class="el-icon-plus"></i>申请退货
            </el-button>
          </div>
          <el-table
            :data="downShopHouseManageInfo.inoutOrders"
            border
            style="width:100%"
          >
            <el-table-column prop="orderId" label="单号" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column prop="personName" label="申请人" align="center" />
            <el-table-column prop="createTime" label="申请时间" align="center" />
            <el-table-column prop="remark" label="备注" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.state=='1001'"
                  type="text"
                  size="small"
                  @click="_openAuditModal(scope.row)"
                >
                  审核
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="_toDetail(scope.row)"
                >
                  详情
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="_deleteUpShopHouse(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="downShopHouseManageInfo.conditions.page"
            :page-size="downShopHouseManageInfo.conditions.row"
            layout="total, prev, pager, next, jumper"
            :total="downShopHouseManageInfo.total"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-inout-order ref="deleteInoutOrder" @refresh="_listInoutOrder" />
    <audit ref="audit" @notifyAuditInfo="_auditOrderState" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryInoutOrder, auditInoutOrder } from '@/api/goods/downShopHouseApi'
import DeleteInoutOrder from '@/components/goods/deleteInoutOrder/deleteInoutOrder'
import Audit from '@/components/common/audit/Audit'

export default {
  components: {
    DeleteInoutOrder,
    Audit
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      downShopHouseManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          personName: '',
          orderId: '',
          orderType: '20000',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      let shopId = await getShopId();
      this.downShopHouseManageInfo.conditions.shopId = shopId
      await this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      this._getDictData()
    },
    async _getDictData() {
      try {
        const {data} = await getDict('inout_order', 'state')
        this.downShopHouseManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrder(page, rows) {
      this.downShopHouseManageInfo.conditions.page = page
      this.downShopHouseManageInfo.conditions.row = rows
      try {
        const res = await queryInoutOrder(this.downShopHouseManageInfo.conditions)
        this.downShopHouseManageInfo.inoutOrders = res.data
        this.downShopHouseManageInfo.total = res.total
        this.downShopHouseManageInfo.records = res.records
        console.log(this.downShopHouseManageInfo.records)
      } catch (error) {
        console.error('获取退货单列表失败:', error)
      }
    },
    _openAddShopHouseModal() {
      this.$router.push('/pages/goods/downShopHouseOutManage')
    },
    _queryShopHouseMethod() {
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetShopHouseMethod() {
      this.downShopHouseManageInfo.conditions = {
        personName: '',
        orderId: '',
        orderType: '20000',
        state: '',
        shopId: this.downShopHouseManageInfo.conditions.shopId,
        page: 1,
        row: 10
      }
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _deleteUpShopHouse(row) {
      this.$refs.deleteInoutOrder.open(row)
    },
    _openAuditModal(row) {
      this.downShopHouseManageInfo.curOrder = row
      this.$refs.audit.open()
    },
    async _auditOrderState(auditInfo) {
      const order = this.downShopHouseManageInfo.curOrder
      order.state = auditInfo.state
      order.stateRemark = auditInfo.remark
      order.shopId = this.downShopHouseManageInfo.conditions.shopId
      try {
        await auditInoutOrder(order)
        this.$message.success('审核成功')
        this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      } catch (error) {
        console.error('审核失败:', error)
      }
    },
    _toDetail(row) {
      this.$router.push(`/pages/goods/upShopHouseDetail?orderId=${row.orderId}`)
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.search-form {
  padding: 18px 0 0;
}
.box-card {
  margin-bottom: 20px;
}
</style>